import { formatToDate } from 'helpers/date';
import { dateToFormat } from 'helpers/formatters/date';
import { formatPercent } from 'helpers/formatters/number';
import { useMemo } from 'react';
import {
  StaticWeightedLineItem,
  StaticWeightedTimeWindow,
} from 'types/StaticWeighted';
import { Column } from 'types/Table';

export type RowType = {
  fromDate: string;
};

export const getRowFormatted = (row: any) => {
  return {
    tabName: row.fromDate,
    data: {
      fromDate: row.fromDate,
      isTimeWindowEnable: true,
    },
  };
};

export const useTable = (
  data: Array<StaticWeightedTimeWindow>,
  onDeleteRow?: (fromDate: string) => void
) => {
  function getColKey(lineItem: StaticWeightedLineItem) {
    return `lineItem${
      lineItem.returnComponentResourceId ||
      lineItem.returnComponentBenchmarkId ||
      lineItem.returnComponent
    }`;
  }

  const columns = useMemo(() => {
    const map: any = {};
    const cols: Array<Column> = [
      {
        Header: 'From Date',
        accessor: 'fromDate',
      },
      {
        Header: 'To Date',
        accessor: 'toDate',
      },
    ];

    data?.forEach((timeWindow: StaticWeightedTimeWindow) => {
      timeWindow.lineItems.forEach((lineItem: StaticWeightedLineItem) => {
        const key = getColKey(lineItem);
        if (!map.hasOwnProperty(key)) {
          map[key] = true;
          const headerText: string = lineItem?.returnComponentName ?? '-';

          cols.push({
            Header: headerText,
            accessor: key,
            Cell: (row) => <div className='text-right'>{row.value}</div>,
            className: 'text-right',
          });
        }
      });
    });

    return cols;
  }, [data]);

  const tableData = useMemo(() => {
    const newData: Array<StaticWeightedTimeWindow> = [];
    data.forEach((timeWindow: StaticWeightedTimeWindow) => {
      const newTimeWindow: any = {
        fromDate: dateToFormat(new Date(timeWindow.fromDate), 'MM/dd/y'),
        toDate: formatToDate(timeWindow.fromDate, timeWindow.toDate),
        lineItems: timeWindow.lineItems,
      };
      timeWindow.lineItems.forEach((lineItem: StaticWeightedLineItem) => {
        const key = getColKey(lineItem);
        newTimeWindow[key] = lineItem.returnComponent
          ? `${lineItem.weight}%`
          : formatPercent(lineItem.weight);
      });
      newData.push(newTimeWindow);
    });

    return newData;
  }, [data]);

  const actionDeleteRow = (
    onCloseModal: any,
    row: StaticWeightedTimeWindow[]
  ) => {
    onDeleteRow?.(row[0].fromDate);
    onCloseModal();
  };

  return {
    data: tableData,
    columns,
    actionDeleteRow,
  };
};
